import { useQuery } from '@tanstack/vue-query'
import { getWithdrawRequestStatusCounts } from '../withdrawRequestsEndpoints'
import { withdrawRequestKeys } from '../withdrawRequestsQueryKeys'

export function useWithdrawRequestStatusCountsQuery() {
  return useQuery({
    queryKey: withdrawRequestKeys.statusCounts(),
    queryFn: () => getWithdrawRequestStatusCounts(),
    staleTime: 1000 * 30,
  })
}
